import { memo, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "./context";
import UiSpinner from "./ui_spinner";
import UserBrandType from "./user_brand_type";
import UiTooltip from "./ui_tooltip";


const UserDisplayList = ({ displayUser, load, showCanvasHandler, setReloadList }) => {

    const { neonUser } = useContext(AppContext)

    useEffect(() => {
        // console.log("USERDISPLAYLIST")
    }, [])

    return (
        <>
            {displayUser.length > 0 ? displayUser.map(x => (
                x.internal_hidden ? null :
                    <tr key={x.id}>
                        <td className="poppins">{x.email}</td>
                        <td className="poppins text-capitalize middle-row-td">{x.first_name}</td>
                        <td className="poppins text-capitalize middle-row-td">{x.role == 'normal' ? 'read only' : x.role}</td>
                        <td className={"poppins text-capitalize middle-row-td " + (x["active?"] ? 'text-success' : 'text-danger')}>
                            {x["active?"] ? 'active' : 'inactive'}
                        </td>
                        <td className="poppins text-capitalize middle-row-td">
                            <UserBrandType x={x} />
                        </td>
                        <td className="poppins middle-row-td">
                            <div className="d-flex gap-1 justify-content-evenly">
                                {x.id == neonUser.user.id || (x.role == "owner" && neonUser.role != "owner") ?
                                    null
                                    :
                                    <>
                                        <UiTooltip title="Edit Account/Brand List">
                                            <i style={{ color: '#650260' }} onClick={() => showCanvasHandler("Edit User", "user_edit", x)} className="bi bi-person-gear fs-4" />
                                        </UiTooltip>
                                        {!x["active?"] &&
                                            <UiTooltip title="Delete Account/Brand List">
                                                <i style={{ color: '#650260' }} onClick={() => showCanvasHandler("Delete User", "user_delete", x)} className="bi bi-trash fs-4" />
                                            </UiTooltip>
                                        }
                                    </>
                                }
                            </div>
                        </td>
                    </tr>
            ))
                : !load &&
                <tr className="text-center">
                    <td colSpan={6} className="poppins text-secondary" onClick={() => setReloadList(true)}>
                        Nothing to show... reload list
                    </td>
                </tr>
            }
            {load &&
                <tr>
                    <td colSpan={6}>
                        <UiSpinner />
                    </td>
                </tr>
            }
        </>
    )
}

export default UserDisplayList